import React, { Component } from "react";

class HopdPapers extends Component {
  render() {
    return (
      <div>
        <h1>Repository of Papers Page</h1>
      </div>
    );
  }
}

export default HopdPapers;
